<template>
  <div class="w-full rounded-lg p-4" :class="getAlertClass()" style="direction: ltr">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VAlert",
  props: ['type'],
  methods: {
    getAlertClass() {
      switch (this.type) {
        case 'success':
          return 'bg-green/30 text-green'
        case 'danger':
          return 'bg-red/30 text-red'
      }
    }
  }
}
</script>

<style scoped>

</style>